// @flow
import type { Latitude, Longitude, Behaviour,
    AllocationRates, DriverIDs, PassengerIDs,
    SuccessfulRides, SuccessRates, TotalBookings, Bookings } from 'types/entities';
import type { Errors } from './errors';

export type EventData = {
  type: number,
  params: Object,
};

// Commented out events have not been implemented.
export const COHORT_DELETED_EVENT: number = 1;
export const DRIVER_NEW_EVENT: number = 2;
export const DRIVER_LOGGED_IN_EVENT: number = 3;
export const DRIVER_LOGGED_OUT_EVENT: number = 4;
export const DRIVER_LOCATION_UPDATE_EVENT: number = 5;
export const DRIVER_DISCONNECTED_EVENT: number = 6;
export const DRIVER_DELETED_EVENT: number = 7;
export const PASSENGER_NEW_EVENT: number = 8;
export const PASSENGER_LOGGED_IN_EVENT: number = 9;
export const PASSENGER_LOGGED_OUT_EVENT: number = 10;
export const PASSENGER_DELETED_EVENT: number = 11;
export const BOOKING_DRIVER_NEW_EVENT: number = 12;
export const BOOKING_DRIVER_BID_EVENT: number = 13;
export const BOOKING_DRIVER_DECLINED_EVENT: number = 14;
export const BOOKING_DRIVER_AWARDED_EVENT: number = 15;
// export const BOOKING_DRIVER_IM_HERE_EVENT: number = 16;
export const BOOKING_DRIVER_PICKED_UP_EVENT: number = 17;
export const BOOKING_DRIVER_DROPPED_OFF_EVENT: number = 18;
export const BOOKING_DRIVER_COMPLETE_EVENT: number = 19;
export const BOOKING_DRIVER_CANCELLED_EVENT: number = 20;
export const BOOKING_DRIVER_RECEIVED_CANCELLATION_EVENT: number = 21;
export const BOOKING_PASSENGER_NEW_EVENT: number = 22;
export const BOOKING_PASSENGER_UNALLOCATED_EVENT: number = 23;
export const BOOKING_PASSENGER_AWARDED_EVENT: number = 24;
export const BOOKING_PASSENGER_PICKED_UP_EVENT: number = 25;
export const BOOKING_PASSENGER_COMPLETED_EVENT: number = 26;
export const BOOKING_PASSENGER_CANCELLED_EVENT: number = 27;
export const BOOKING_PASSENGER_RECEIVED_CANCELLATION_EVENT: number = 28;
export const DRIVER_AVAILABILITY_UPDATE_EVENT: number = 29;
export const BOOKING_DRIVER_IGNORED_EVENT: number = 30;
// export const BOOKING_DRIVER_ADDITIONAL_DROPOFF_EVENT: number = 31;
// export const SIMULATION_BOOKINGS_CREATED_EVENT: number = 32;
export const SIMULATION_BOOKINGS_COMPLETE_EVENT: number = 33;
export const SIMULATION_BOOKINGS_TIMEOUT_EVENT: number = 34;
// export const PASSENGERS_LOGGED_IN: number = 35;
export const SIMULATION_RESOURCE_CREATION_ERROR: number = 36;
export const RESOURCE_CREATION_STATUS_EVENT: number = 39;
export const DRIVER_AUTO_ACCEPT_UPDATE_EVENT: number = 40;

export type DriverEvent = {
  driverID: string,
};

export type DriverLocationUpdateEvent = DriverEvent & {
  latitude: Latitude,
  longitude: Longitude,
};

export type DriverLoggedInEvent = DriverEvent & {
  behaviour: Behaviour,
};

export type PassengerEvent = {
  passengerID: string,
};

export type PassengerLoggedInEvent = PassengerEvent & {
  behaviour: Behaviour,
};

export type BookingEvent = {
  bookingID: string,
};

export type BookingPassengerEvent = PassengerEvent & BookingEvent;
export type BookingDriverEvent = DriverEvent & BookingEvent;

export type DriverAvailabilityUpdateEvent = DriverEvent & {
  availability: boolean,
};

export type DriverAutoAcceptUpdateEvent = DriverEvent & {
  isTurnedOn: boolean,
};

export type SimulationReportEvent = {
  successfulRides: SuccessfulRides,
  totalBookings: TotalBookings,
  successRate: SuccessRates,
  allocationRate: AllocationRates,
  passengerIDs: PassengerIDs,
  driverIDs: DriverIDs,
  errors: Errors,
  bookings: Bookings,
}

export type ResourceCreationStatusEvent = {
  status: number,
  error: Errors,
}



/** WEBPACK FOOTER **
 ** ./src/js/types/events.js
 **/